import I18n from 'i18n-js';
import React from 'react';

import experiments from '@reverbdotcom/commons/src/experiments';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { RCAlertBox, RCIcon } from '@reverbdotcom/cadence/components';
import { WarningIcon } from '@phosphor-icons/react';

export function ShippingLabelOutageBanner() {
  const shouldShowBanner = useExpEnabled(experiments.SHIPPING_LABEL_OUTAGE_BANNER);

  if (!shouldShowBanner) { return null; }

  return (
    <div className="mb-8">
      <RCAlertBox type="warning">
        <RCIcon icon={<WarningIcon />} size="inline" spacing="right" />
        {I18n.t('discovery.dashboard.selling.shippingLabels.shippingRates.shippingLabelOutageDefaultText')}
      </RCAlertBox>
    </div>
  );
}

export default ShippingLabelOutageBanner;
